module.exports = __webpack_public_path__ + "img/CH5.83a253cf.jpg";